import { Log } from '@/types/logs'
import { Tooltip } from '@/ui/Tooltip'
import ChatIcon from '../../../assets/chat-blue.svg'
import styles from '../../CombinedLogs.module.scss'

interface Props {
    log: Log
}

export const CommentIcon = ({ log }: Props) => {
    const formatCommentDate = (dateString: string): string => {
        const date = new Date(dateString)
        const now = new Date()

        const isToday =
            date.getDate() === now.getDate() &&
            date.getMonth() === now.getMonth() &&
            date.getFullYear() === now.getFullYear()

        const timeStr = date.toLocaleTimeString([], {
            hour: '2-digit',
            minute: '2-digit',
            hour12: false,
        })

        if (isToday) {
            return `${timeStr} today`
        }

        const day = String(date.getDate()).padStart(2, '0')
        const month = String(date.getMonth() + 1).padStart(2, '0')

        return `${timeStr} ${day}/${month}`
    }

    if (log.unfinishedFlagMetadata) {
        return (
            <Tooltip
                placement="bottom-end"
                crossAxis={10}
                tooltip={
                    <div className={styles.commentTooltipCard}>
                        <div className={styles.header}>
                            <h3 className={styles.title}>Mileage Clerk Comment</h3>
                        </div>

                        <div className={styles.content}>
                            <p className={styles.body}>{log.unfinishedFlagMetadata.comment}</p>

                            <div className={styles.meta}>
                                <span className={styles.author}>{log.unfinishedFlagMetadata.author}</span>
                                <span className={styles.time}>
                                    {formatCommentDate(log.unfinishedFlagMetadata.createdAt)}
                                </span>
                            </div>
                        </div>
                    </div>
                }
            >
                <div className={styles.chatIconWrapper}>
                    <ChatIcon />
                </div>
            </Tooltip>
        )
    }
    return null
}
